import { render, staticRenderFns } from "./EventBannerGroup.vue?vue&type=template&id=036b1c3c&scoped=true&"
import script from "./EventBannerGroup.vue?vue&type=script&lang=js&"
export * from "./EventBannerGroup.vue?vue&type=script&lang=js&"
import style0 from "./EventBannerGroup.vue?vue&type=style&index=0&id=036b1c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b1c3c",
  null
  
)

export default component.exports